<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M6.328 19.243 A12.4 4 -34 0 1 3.159 14.546 M17.672 4.757 A12.4 4 -34 0 1 20.841 9.454"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M6.328 19.243 A9.2 9.2 0 1 1 20.841 9.454 M20.979 14.005 A9.2 9.2 0 0 1 10.495 21.076"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M20.841 9.454 A12.4 4 -34 0 1 6.328 19.243"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
